/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsInfo: {
  name: 'info';
  data: string;
} = {
  name: 'info',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Z" fill="currentColor"/></svg>`,
};
